import Cookies from 'js-cookie'

//数据 state
const state = {
  language: Cookies.get('language') || 'zh'
}

//获取数据 getters
const getters = {
  language: state => state.language
}

//修改数据 mutations
const mutations = {
  SET_LANGUAGE: (state, language) => {
    state.language = language
    Cookies.set('language', language)
  }
}

export default {
  state,
  getters,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/lang.js